<template>
    <div>
        <tr :class="{ 'parent-row': item.children, 'child-row': !item.children }" style="width: 100%" @click="toggleRow(itemKey)">
            <template v-if="item.children">
                <td v-for="(n, index) in parentChild" :key="index"></td>
                <td style="width: 80em">
                    <i class="fa-solid fa-chevron-down" v-if="settingsState.expandedRows.includes(itemKey)"></i> {{ item.name }} 
                </td>
            </template>
            <template v-else>
                <td v-for="(n, index) in parentChild" :key="index"  style="width: 100%"></td>
                <td class="desc-cell">{{ item.description }}</td>
                <td class="badge-cell">
                    <span
                    class="text-uppercase"
                    :class="getBadge(item.type)"
                    >{{ item.type }}</span
                  >
                </td>
                <td class="value-cell">{{ item.value }}</td>
                <td class="option-cell">
                    <button v-tooltip="'Edit Setting'" @click="editSetting(item)" type="button" class="btn btn-sm btn-info m-1">
                        <em class="fa fa-edit fa-fw"></em>
                    </button>
                </td>
            </template>
        </tr>

        <template v-if="settingsState.expandedRows.includes(itemKey)">
            <SettingTreeTableRow
                v-for="child in item.children"
                :key="child.name"
                :item="child"
                :parentChild="1 + parentChild"
                @toggle="toggleRow"
                @edit="editSetting"
            />
        </template>
    </div>
</template>

<script>
import { SettingsState } from '@/stores/pages/Admin/Settings.ts';

export default {
    name: 'SettingTreeTableRow',
    props: {
        item: {
            type: Object,
            required: true
        },
        parentChild: {
            type: Number,
            required: false,
            default: 0,
        }
    },
    data() {
        const settingsState = SettingsState();
        return {
            settingsState,
        };
    },
    computed: {
        itemKey() {
            return this.item.settingNumber ?? this.item.name
        }
    },
    methods: {
        toggleRow(itemKey) {
            this.$emit('toggle', itemKey)
        },
        editSetting(item) {
            this.$emit('edit', item);
        },
        getBadge(status) {
            switch (status) {
                case "integer":
                    return "badge bg-info-dark";
                case "double":
                    return "badge bg-purple";
                case "string":
                    return "badge bg-warning";
                case "boolean":
                    return "badge bg-green";
                default:
                    return "badge bg-red text-white";
            }
        },
    }
}
</script>

<style>
.parent-row {
    cursor: pointer;
    font-weight: bold;
}

.parent-row:hover {
    background-color: rgb(250, 250, 250);
}

.child-row:hover {
    background-color: rgb(250, 250, 250);
}

.mlc {
    margin-left: 2em;
}

td {
    font-size: 17;
    overflow: visible;
    overflow-wrap: break-word;
}

.desc-cell {
    min-width: 22em; 
    max-width: 22em;
}

.badge-cell {
    text-align: center;
    min-width: 5em; 
    max-width: 5em;
}

.value-cell {
    text-align: center;
    min-width: 33em; 
    max-width: 33em;
}

.option-cell {
    text-align: center;
    min-width: 5em; 
    max-width: 5em;
}
</style>
